

import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import cx from 'classnames';
import FileTypeIcon from '../../FileTypeIcon';
import '../styles/_font-preview.scss';







function getFontFace(asset, fontFamily) {
  const { assetFiles } = asset;

  return `@font-face {
    font-family: '${fontFamily}';
    src: url(${assetFiles.ORIGINAL.sourceUrl});
  }`;
}

function FontPreview({ asset, hideFileTypeIcon, smallFont }) {
  const { assetId } = asset;
  const fontFamily = `CustomFont-${assetId}`;

  return (
    <div className="font-preview">
      <Helmet>
        <style type="text/css">
          {`${getFontFace(asset, fontFamily)}`}
        </style>
      </Helmet>
      <p
        style={{ fontFamily: `${fontFamily}, Poppins` }}
        className={cx('font-preview__snippet', { 'font-preview__snippet--small': smallFont })}>

        ABC abc
      </p>
      {!hideFileTypeIcon && <FileTypeIcon name="typography" size={20} />}
    </div>);

}

export default memo(FontPreview);